import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';

import { ContaService } from '../shared/conta.service';
import {
  ContaParcelaNotaFiscalContaPagar,
  NotaFiscalContaPagarContaRequest,
  OPCOES_TIPO_NOTA_FISCAL_CONTA_PAGAR,
  StatusNotaFiscalContaPagar
} from '../shared/nota-fiscal-conta-pagar.model';

export interface NotaFiscalContaPagarContaDialogData {
  contaId: number;
}

/** Linha da tabela de parcelas, com o texto da nota atual já montado. */
interface ParcelaDaNota extends ContaParcelaNotaFiscalContaPagar {
  notaAtualFormatada: string;
}

/**
 * Informa uma nota fiscal do fornecedor para a conta a pagar toda: a nota cobre todas as parcelas que não
 * estão canceladas nem substituídas, cada uma com o valor antes das retenções.
 */
@Component({
  selector: 'app-nota-fiscal-conta-pagar-conta',
  templateUrl: 'nota-fiscal-conta-pagar-conta.component.html',
  styleUrls: ['nota-fiscal-conta-pagar-conta.component.css'],
})
export class NotaFiscalContaPagarContaComponent implements OnInit {

  maximizado = false;
  form: FormGroup;
  opcoesTipo = OPCOES_TIPO_NOTA_FISCAL_CONTA_PAGAR;

  parcelas: ParcelaDaNota[] = [];
  carregou = false;

  constructor(
    private dialogRef: MatDialogRef<NotaFiscalContaPagarContaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NotaFiscalContaPagarContaDialogData,
    private formBuilder: FormBuilder,
    private contaService: ContaService,
    private snackBar: MatSnackBar
  ) { }

  get valoresBrutos(): FormArray {
    return this.form.get('valoresBrutos') as FormArray;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      tipoDocumentoFiscal: [null, Validators.required],
      numero: ['', [Validators.required, Validators.maxLength(20)]],
      serie: ['', Validators.maxLength(10)],
      dataEmissao: [null, Validators.required],
      valoresBrutos: this.formBuilder.array([], Validators.required)
    });

    this.restaurarDialog();
    this.buscarParcelas();
  }

  buscarParcelas(): void {
    this.contaService.getParcelasNotaFiscalContaAPagar(this.data.contaId).subscribe(resposta => {
      this.parcelas = (resposta.body ?? []).map(parcela => ({
        ...parcela,
        notaAtualFormatada: parcela.notaFiscal?.status === StatusNotaFiscalContaPagar.Ativa
          ? parcela.notaFiscal.numero
          : ''
      }));

      this.parcelas.forEach(parcela =>
        this.valoresBrutos.push(this.formBuilder.control(parcela.valorBruto, Validators.required)));

      this.carregou = true;
    });
  }

  trackByParcela(_indice: number, parcela: ParcelaDaNota): number {
    return parcela.contaParcelaId;
  }

  salvar(): void {
    const valores = this.form.getRawValue();

    const notaFiscal: NotaFiscalContaPagarContaRequest = {
      tipoDocumentoFiscal: valores.tipoDocumentoFiscal,
      numero: valores.numero,
      serie: valores.serie || null,
      dataEmissao: moment(valores.dataEmissao).format('YYYY-MM-DD'),
      parcelas: this.parcelas.map((parcela, indice) => ({
        contaParcelaId: parcela.contaParcelaId,
        valorBruto: valores.valoresBrutos[indice]
      }))
    };

    this.contaService.postInformarNotaFiscalContaAPagar(this.data.contaId, notaFiscal).subscribe(() => {
      this.snackBar.open('Nota fiscal salva com sucesso', 'Fechar', {
        duration: 5000, panelClass: ['mat-toolbar', 'sucess']
      });

      this.dialogRef.close(true);
    });
  }

  fecharDialog(): void {
    this.dialogRef.close();
  }

  maximizarDialog(): void {
    this.dialogRef.updateSize('100%', '100%');
    this.maximizado = true;
  }

  restaurarDialog(): void {
    if (window.innerWidth < 1024) {
      this.dialogRef.updateSize('90%', '');
    } else {
      this.dialogRef.updateSize('60%', '');
    }
    this.maximizado = false;
  }
}
